import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>AsterIsland - Premium Tea, Coffee, and 3D Models</title>
        <meta name="description" content="Discover premium tea, coffee, and exclusive 3D models at AsterIsland - your gateway to refined beverages and digital art." />
      </Helmet>

      <div className="relative">
        {/* Hero Section */}
        <div className="relative bg-gradient-to-br from-primary-800 to-primary-900 py-24 sm:py-32">
          <div className="absolute inset-0 overflow-hidden">
            <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1510218830377-2e994ea9087d?q=80&w=1916&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')] bg-cover bg-center opacity-10"></div>
          </div>
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-center"
            >
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-display text-white mb-6 leading-tight">
                Welcome to AsterIsland
              </h1>
              <p className="text-xl md:text-2xl text-primary-100 max-w-3xl mx-auto font-light">
                Your curated destination for premium beverages and digital art
              </p>
            </motion.div>
          </div>
        </div>

        {/* Featured Sections */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-16 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="card"
            >
              <div className="h-48 bg-[url('https://images.unsplash.com/photo-1534447677768-be436bb09401?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
              <div className="p-6">
                <h2 className="text-2xl font-display text-primary-900 mb-4">
                  Dragonsworn Portfolio
                </h2>
                <p className="text-primary-600 mb-6">
                  Explore our collection of exclusive 3D models and digital art creations.
                </p>
                <a
                  href="https://portfolio.asterisland.com/"
                  className="btn-primary"
                >
                  View Portfolio
                </a>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              className="card"
            >
              <div className="h-48 bg-[url('coyoteas.jpg')] bg-cover bg-center"></div>
              <div className="p-6">
                <h2 className="text-2xl font-display text-primary-900 mb-4">
                  Coy O'Teas
                </h2>
                <p className="text-primary-600 mb-6">
                  Discover our selection of premium teas, incense, and unique gifts.
                </p>
                <a
                  href="https://coyoteas.com/"
                  className="btn-primary"
                >
                  Shop Now
                </a>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6 }}
              className="card"
            >
              <div className="h-48 bg-[url('https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
              <div className="p-6">
                <h2 className="text-2xl font-display text-primary-900 mb-4">
                  Saltwood Tea & Coffee
                </h2>
                <p className="text-primary-600 mb-6">
                  Experience premium single-source coffee and luxury loose leaf teas.
                </p>
                <a
                  href="https://saltwood.asterisland.com/"
                  className="btn-primary"
                >
                  Browse Selection
                </a>
              </div>
            </motion.div>
          </div>
        </div>

        {/* About Section */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8 }}
            className="text-center max-w-3xl mx-auto"
          >
            <h2 className="text-3xl md:text-4xl font-display text-primary-900 mb-6">
              Curated Excellence
            </h2>
            <p className="text-lg text-primary-600 leading-relaxed">
              At AsterIsland, we bridge the world of digital artistry with exceptional beverages. 
              Our carefully selected partners offer the finest in tea, coffee, and 3D model designs, 
              ensuring an unparalleled experience for our discerning customers.
            </p>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default Home;